import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  minus1djrl64vbav3y as minus,
  plus20p0vtfmu0596 as plus,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  FormSelector1zdq40oqbcvms as FormSelector,
  matches2uu672wulv59r as matches,
  FormRendererv0cfjgipxuxv as FormRenderer,
  priority7vn90mx06311 as priority,
  Companion_instancegwok6qx7et5m as Companion_instance,
  Companion_instance17v8p6g2424o4 as Companion_instance_0,
  ViewRenderer1i6kznnbg7y21 as ViewRenderer,
  form1pdmcqj387954 as form,
  defaultColumns2bko8gwvd6xmb as defaultColumns,
  get_kind27kjvyfnc9an8 as get_kind,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  get_basePriority3aha966bwjyn2 as get_basePriority,
  Generator2kgtccb0jt0mi as Generator,
  Generator1qrulkrel7e5m as Generator_0,
} from './FormRenderer.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_padded3m3frjnjujncx as get_padded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrollsHorizontally166yklfalehnr as get_scrollsHorizontally,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { coerceAtLeastklytehohcpeq as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { lensPathswr2at65kgwf as lensPath } from '../../serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  forEach37zw770vd3h4l as forEach,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { text1v7b2bj2gx49v as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { get_displayName274cn1h5q1fsg as get_displayName } from './annotationReaders.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  DataClassPath3joljqmfaqhxf as DataClassPath,
  DataClassPathSelf9694s3fei65z as DataClassPathSelf,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { closePopovers89geeulkriez as closePopovers } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/HasId.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  serializer1cdzkc3mnhoc4 as serializer,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  FormLayoutPreferences_Field_getInstanceniwfeoycub95 as FormLayoutPreferences_Field_getInstance,
  Companion_getInstance17fcxlkqs50ig as Companion_getInstance,
} from './helpers.mjs';
import { listElement2fr0t0e999y76 as listElement } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { get_serializableProperties2tbouuwr11am9 as get_serializableProperties } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import {
  SizeConstraints24axz83pb17aw as SizeConstraints,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  Companion_getInstance3e8hrj2m27b5h as Companion_getInstance_1,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { changingSizeConstraints2ompnjjk125zt as changingSizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  ImportantSemantic_getInstance19jf9bmkjsdl8 as ImportantSemantic_getInstance,
  ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import { DataClassPathSerializer1pr4zwqha0dv8 as DataClassPathSerializer } from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPathSerializer.mjs';
import { Recycler21f097l2zl8cft as Recycler2 } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.mjs';
import { LimitReadable2ecfn2s8p9gvk as LimitReadable } from '../../lightningserver/db/deprecated.mjs';
import {
  reactive2pl1t9wy5gll5 as reactive,
  reactiveScope1fcalsbdr0hgb as reactiveScope,
} from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { children3sl29z5no2wyp as children } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.ext.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ie1_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.he1_1(tmp$ret$0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function view$_anonymous_$renderer_dr147b(rendererCache, $formModule, path) {
  // Inline function 'kotlin.collections.getOrPut' call
  var value = rendererCache.p3(path);
  var tmp;
  if (value == null) {
    var tmp_0 = path.h2j();
    var tmp0_safe_receiver = lastOrNull(path.l4q());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o2j();
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_1 = emptyList();
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var answer = $formModule.bdu(new (FormSelector())(tmp_0, tmp_1, TableRenderer_getInstance().jdw_1, true));
    rendererCache.s3(path, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  return tmp;
}
function view$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$content_5qr09z(_this__u8e3s4, anyCols, $it, rendererCache, $formModule) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  var $this$row = view;
  forEach($this$row, anyCols, ($this$forEach, col) => {
    var render = view$_anonymous_$renderer_dr147b(rendererCache, $formModule, col);
    $this$forEach.lbb($this$forEach.kbb(get_padded($this$forEach), sizeConstraints($this$forEach, VOID, VOID, VOID, VOID, VOID, get_rem(coerceAtLeast(render.p1().hds_1, 5.0)))), render.vds()($this$row, null, lensPath($it, col)));
    return Unit_instance;
  });
  _this__u8e3s4.hbb(p, view);
  return view;
}
function TableRenderer$form$lambda($this$FormRenderer, _unused_var__etf5q3, mutable) {
  return text($this$FormRenderer, 'TODO');
}
function TableRenderer$view$lambda$lambda(it) {
  return get_displayName(it);
}
var TableRenderer$view$lambda$slambdaClass;
function TableRenderer$view$lambda$slambda() {
  if (TableRenderer$view$lambda$slambdaClass === VOID) {
    class $ {
      constructor($anyCols, $it) {
        this.je1_1 = $anyCols;
        this.ke1_1 = $it;
      }
      uao($completion) {
        var _receiver__tnumb7 = this.je1_1;
        _receiver__tnumb7.oam(minus(_receiver__tnumb7.f2(), this.ke1_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    TableRenderer$view$lambda$slambdaClass = $;
  }
  return TableRenderer$view$lambda$slambdaClass;
}
function TableRenderer$view$lambda$slambda_0($anyCols, $it) {
  var i = new (TableRenderer$view$lambda$slambda())($anyCols, $it);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var TableRenderer$view$lambda$slambdaClass_0;
function TableRenderer$view$lambda$slambda_1() {
  if (TableRenderer$view$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($anyCols, $newField, $$this$button) {
        this.le1_1 = $anyCols;
        this.me1_1 = $newField;
        this.ne1_1 = $$this$button;
      }
      uao($completion) {
        var _receiver__tnumb7 = this.le1_1;
        var tmp = _receiver__tnumb7.f2();
        var tmp_0 = this.me1_1.f2();
        _receiver__tnumb7.oam(plus(tmp, tmp_0 instanceof DataClassPath() ? tmp_0 : THROW_CCE()));
        closePopovers(this.ne1_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    TableRenderer$view$lambda$slambdaClass_0 = $;
  }
  return TableRenderer$view$lambda$slambdaClass_0;
}
function TableRenderer$view$lambda$slambda_2($anyCols, $newField, $$this$button) {
  var i = new (TableRenderer$view$lambda$slambda_1())($anyCols, $newField, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TableRenderer$view$lambda(it) {
  var tmp0_safe_receiver = (!(it == null) ? isInterface(it, HasId()) : false) ? it : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f40();
  return tmp1_elvis_lhs == null ? it : tmp1_elvis_lhs;
}
function Link$_get_to_$ref_jq7esp(p0) {
  return () => p0.zbv_1;
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return (_this__u8e3s4) => {
    p0.kbw(_this__u8e3s4);
    return Unit_instance;
  };
}
var TableRenderer$view$lambda$slambdaClass_1;
function TableRenderer$view$lambda$slambda_3() {
  if (TableRenderer$view$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($action, $it) {
        this.he1_1 = $action;
        this.ie1_1 = $it;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    TableRenderer$view$lambda$slambdaClass_1 = $;
  }
  return TableRenderer$view$lambda$slambdaClass_1;
}
function TableRenderer$view$lambda$slambda_4($action, $it) {
  var i = new (TableRenderer$view$lambda$slambda_3())($action, $it);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var TableRendererClass;
function TableRenderer() {
  if (TableRendererClass === VOID) {
    class $ {
      constructor() {
        TableRenderer_instance = this;
        this.hdw_1 = 'Table';
        this.idw_1 = ListSerializer(serializer(Unit_instance)).az().h10();
        this.jdw_1 = FormLayoutPreferences_Field_getInstance();
      }
      i20() {
        return this.hdw_1;
      }
      h94() {
        return this.idw_1;
      }
      kdu(module_0, selector) {
        return Companion_getInstance().mdu_1;
      }
      oe1(serializer) {
        var tmp = ensureNotNull(listElement(serializer));
        return isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
      }
      fdu(module_0, selector) {
        return matches.call(this, module_0, selector) && !(get_serializableProperties(this.oe1(selector.gdu_1)) == null);
      }
      tdu(module_0, selector) {
        var innerSer = this.oe1(selector.gdu_1);
        var tmp = module_0.adu(selector.copyChangingType(innerSer, VOID, this.jdw_1));
        var inner = isInterface(tmp, FormRenderer()) ? tmp : THROW_CCE();
        return priority.call(this, module_0, selector) * (inner.p1().equals(Companion_getInstance().mdu_1) ? 1.1 : 0.6);
      }
      ndu(module_0, selector) {
        var innerSer = ensureNotNull(listElement(selector.gdu_1));
        var tmp = module_0.adu(selector.copyChangingType(innerSer, VOID, this.jdw_1));
        var inner = isInterface(tmp, FormRenderer()) ? tmp : THROW_CCE();
        var tmp_0 = Companion_instance;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.odu(module_0, this, tmp_1, VOID, VOID, TableRenderer$form$lambda);
        return isInterface(tmp_2, FormRenderer()) ? tmp_2 : THROW_CCE();
      }
      pdu(module_0, selector) {
        var tmp = selector.gdu_1;
        var innerSer = this.oe1(isInterface(tmp, KSerializer()) ? tmp : THROW_CCE());
        var tmp_0 = Companion_instance_0;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.qdu(module_0, this, tmp_1, VOID, VOID, ($this$ViewRenderer, _unused_var__etf5q3, readable) => $this$ViewRenderer.lbb(sizeConstraints($this$ViewRenderer, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(30)), TableRenderer_getInstance().kdw($this$ViewRenderer, module_0, innerSer, new (Constant())(_Constant___init__impl__v45mub(readable)))));
        return isInterface(tmp_2, ViewRenderer()) ? tmp_2 : THROW_CCE();
      }
      pe1(writer, formModule, innerSer, readable, columns, linkTo, action) {
        // Inline function 'kotlin.with' call
        var tmp = ensureNotNull(get_serializableProperties(innerSer));
        var properties = isArray(tmp) ? tmp : THROW_CCE();
        var rendererCache = HashMap().n8();
        var anyCols = isInterface(columns, MutableReactiveValue()) ? columns : THROW_CCE();
        var tmp_0 = get_scrollsHorizontally(writer);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(writer.pc());
        var tmp0_elvis_lhs = writer.ebb_1;
        var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
        writer.gbb(p, view);
        view.zbm(true);
        var tmp_1 = get_expanding(view);
        var tmp_2 = view.kbb(tmp_1, changingSizeConstraints(view, ($this$changingSizeConstraints) => {
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0;
          var _iterator__ex2g4s = $this$changingSizeConstraints.daj(anyCols).m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp = sum;
            sum = tmp + (coerceAtLeast(view$_anonymous_$renderer_dr147b(rendererCache, formModule, element).p1().hds_1, 5.0) + 2.0);
          }
          var tmp$ret$1 = sum;
          return new (SizeConstraints())(VOID, VOID, VOID, VOID, VOID, get_rem(tmp$ret$1 + 5.0));
        }));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        var tmp_3 = get_padded(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(false);
        forEach(view_2, anyCols, ($this$forEach, it) => {
          var tmp = sizeConstraints($this$forEach, VOID, VOID, VOID, VOID, VOID, get_rem(coerceAtLeast(view$_anonymous_$renderer_dr147b(rendererCache, formModule, it).p1().hds_1, 5.0)));
          // Inline function 'com.lightningkite.kiteui.views.important' call
          var tmp$ret$2 = $this$forEach.jbb(ImportantSemantic_getInstance());
          var tmp_0 = $this$forEach.kbb(tmp, tmp$ret$2);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$forEach.pc());
          var tmp0_elvis_lhs = $this$forEach.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
          $this$forEach.gbb(p, view);
          view.zbm(false);
          var tmp_1 = view.kbb(get_centered(view), get_expanding(view));
          var tmp_2 = it.l4q();
          view.lbb(tmp_1, text(view, joinToString(tmp_2, ' ', VOID, VOID, VOID, VOID, TableRenderer$view$lambda$lambda)));
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Button())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.bb9(get_px(0));
          view_0.lbb(get_centered(view_0), icon(view_0, Companion_getInstance_0().vcf_1.id5(get_rem_0(1), get_rem_0(1)), 'Remove Column'));
          onClick(view_0, VOID, VOID, TableRenderer$view$lambda$slambda_0(anyCols, it));
          view.hbb(p_0, view_0);
          $this$forEach.hbb(p, view);
          $this$forEach.lbb(tmp_0, view);
          return Unit_instance;
        });
        view_1.hbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (MenuButton())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.gbb(p_3, view_3);
        view_3.bb9(get_px(0));
        view_3.lbb(get_centered(view_3), icon(view_3, Companion_getInstance_0().ycf_1.id5(get_rem_0(1), get_rem_0(1)), 'Add'));
        view_3.dc4(Companion_getInstance_1().acr_1);
        view_3.ac4_1 = true;
        view_3.gc4(($this$opensMenu) => {
          var newField = Signal().hak(new (DataClassPathSelf())(innerSer));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$opensMenu.pc());
          var tmp0_elvis_lhs = $this$opensMenu.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$opensMenu : tmp0_elvis_lhs;
          $this$opensMenu.gbb(p, view);
          view.zbm(true);
          form(view, formModule, new (DataClassPathSerializer())(innerSer), newField);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Button())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          text(view_0, 'OK');
          onClick(view_0, VOID, VOID, TableRenderer$view$lambda$slambda_2(anyCols, newField, view_0));
          view.hbb(p_0, view_0);
          $this$opensMenu.hbb(p, view);
          return Unit_instance;
        });
        view_1.hbb(p_3, view_3);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_3, view_1);
        var tmp_4 = view_0.kbb(get_expanding(view_0), view_0.jbb(ListSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.recyclerView' call
        // Inline function 'kotlin.apply' call
        var this_0 = new (Recycler2())(view_0, true);
        var $this$recyclerView = this_0;
        reactive($this$recyclerView, ($this$reactive) => {
          var inner = $this$reactive.daj(readable);
          var tmp;
          if (isInterface(inner, LimitReadable())) {
            var tmp_0;
            if (inner.re1() < ($this$reactive.daj($this$recyclerView.xdj()) + 50 | 0)) {
              inner.qe1($this$reactive.daj($this$recyclerView.xdj()) + 100 | 0);
              tmp_0 = Unit_instance;
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        });
        var tmp_5 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(readable)));
        var tmp_6 = TableRenderer$view$lambda;
        children($this$recyclerView, tmp_5, tmp_6, ($this$children, it) => {
          var tmp;
          if (!(linkTo == null)) {
            // Inline function 'com.lightningkite.kiteui.views.card' call
            var tmp_0 = $this$children.jbb(CardSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.link' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (Link())($this$children.pc());
            var tmp0_elvis_lhs = $this$children.ebb_1;
            var p = tmp0_elvis_lhs == null ? $this$children : tmp0_elvis_lhs;
            $this$children.gbb(p, view);
            view$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$content_5qr09z(view, anyCols, it, rendererCache, formModule);
            var tmp_1 = KMutableProperty0();
            var tmp_2 = Link$_get_to_$ref_jq7esp(view);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_0 = getPropertyCallableRef('to', 0, tmp_1, tmp_2, Link$_set_to_$ref_i9gu5x(view));
            reactiveScope(view, ($this$reactiveScope) => {
              var tmp$ret$29 = linkTo($this$reactiveScope.daj(it));
              this_0.set(tmp$ret$29);
              return Unit_instance;
            });
            $this$children.hbb(p, view);
            tmp = $this$children.lbb(tmp_0, view);
          } else if (!(action == null)) {
            // Inline function 'com.lightningkite.kiteui.views.card' call
            var tmp_3 = $this$children.jbb(CardSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (Button())($this$children.pc());
            var tmp0_elvis_lhs_0 = $this$children.ebb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? $this$children : tmp0_elvis_lhs_0;
            $this$children.gbb(p_0, view_0);
            view$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$content_5qr09z(view_0, anyCols, it, rendererCache, formModule);
            onClick(view_0, VOID, VOID, TableRenderer$view$lambda$slambda_4(action, it));
            $this$children.hbb(p_0, view_0);
            tmp = $this$children.lbb(tmp_3, view_0);
          } else {
            // Inline function 'com.lightningkite.kiteui.views.card' call
            var tmp$ret$38 = $this$children.jbb(CardSemantic_getInstance());
            tmp = $this$children.lbb(tmp$ret$38, view$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$content_5qr09z($this$children, anyCols, it, rendererCache, formModule));
          }
          return tmp;
        });
        view_0.lbb(tmp_4, this_0);
        view.hbb(p_0, view_0);
        view.lbb(tmp_2, view_0);
        writer.hbb(p, view);
        return writer.lbb(tmp_0, view);
      }
      kdw(writer, formModule, innerSer, readable, columns, linkTo, action, $super) {
        columns = columns === VOID ? Signal().hak(defaultColumns(innerSer)) : columns;
        linkTo = linkTo === VOID ? null : linkTo;
        action = action === VOID ? null : action;
        return $super === VOID ? this.pe1(writer, formModule, innerSer, readable, columns, linkTo, action) : $super.pe1.call(this, writer, formModule, innerSer, readable, columns, linkTo, action);
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).rdu = get_nullable;
    protoOf($).sdu = get_annotation;
    protoOf($).wds = get_handlesField;
    protoOf($).edu = get_basePriority;
    initMetadataForObject($, 'TableRenderer', VOID, VOID, [Generator(), Generator_0()]);
    TableRendererClass = $;
  }
  return TableRendererClass;
}
var TableRenderer_instance;
function TableRenderer_getInstance() {
  if (TableRenderer_instance === VOID)
    new (TableRenderer())();
  return TableRenderer_instance;
}
//region block: exports
export {
  TableRenderer_getInstance as TableRenderer_getInstance1laavxqxr29w3,
};
//endregion

//# sourceMappingURL=TableRenderer.mjs.map
